import React from "react";
import Framework from "@beardeddevops/react.framework";
import Types from "constants/Types";
import ObjectOverride from "components/ObjectOverride";

/**
 *  @property {Exports_Object} state
 *  @property {object} model
 *  @property {Exports_Properties} model.properties
 *  @property {Exports_Is} model.is
 *  @property {Exports_Has} model.has
 */
export default class ExportObject extends ObjectOverride {
	constructor(props) {
		super(props, Types.Exports._name);
	}

	/**
	 * @param prevProps
	 * @param {Exports_Object} prevState
	 * @param snapshot
	 */
	componentDidUpdate(prevProps, prevState, snapshot) {
		super.componentDidUpdate(prevProps, prevState, snapshot);

		/** @type {Exports_Object} object */
		let object = this.state;

		if (typeof this.props.updateName === 'function') {
			this.props.updateName(object.name);
		}
	}

	form = () => {
		/** @type {Exports_Properties} properties */
		let properties = this.model.properties;
		/** @type {Exports_Object} object */
		let object = this.state;
		let {loading} = this.state;

		return (
			<div>
				<fieldset>
					<div className={"row"}>

						<div className={"col-md"}>
							<h4 className="section-title">Export Information</h4>
							<div className="form-group">
								<Framework.Elements.TextField
									property={properties.name}
									value={object.name}
									error={object.name_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							<div className="form-group">
								<Framework.Elements.TextField
									property={properties.address}
									value={object.address}
									error={object.address_error}
									update={this.handleTextFieldPropertyUpdate}
									multiline={4}
								/>
							</div>
						</div>
					</div>
				</fieldset>

				<Framework.Elements.LoadingSpinner isLoading={loading}/>
			</div>
		)
	};

}
